import React from "react";
import { NavLink } from "react-router-dom";
import { IoPerson, IoPricetag, IoHome, IoBookmark, IoPeopleCircleOutline, IoReceiptOutline, IoDocumentText, IoConstruct, IoBriefcaseOutline, IoReaderOutline, IoTvOutline } from "react-icons/io5";
import { useSelector } from "react-redux";

const Sidebar = () => {
 
  const { user } = useSelector((state) => state.auth);

  return (
    <div>
      <aside className="menu pl-2 has-shadow">
        <p className="menu-label label mb-1 has-text-white">General</p>
        <ul className="menu-list">
          <li>
            <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/dashboard"}>
              <IoHome /> Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/tickets"}>
              <IoDocumentText /> Tickets
            </NavLink>
          </li>
        </ul>
        <p className="menu-label label mb-1 has-text-white">Transaction</p>
        <ul className="menu-list">
          <li>
            <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/contracts"}>
              <IoReceiptOutline /> Contracts
            </NavLink>
          </li>
          <li>
            <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/services"}>
              <IoConstruct /> Services
            </NavLink>
          </li>
        </ul>
        <p className="menu-label label mb-1 has-text-white">Reporting</p>
        <ul className="menu-list mb-2">
          <li>
            <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/reporttickets"}>
              <IoReaderOutline /> Report Ticket
            </NavLink>
          </li>
          <li>
            <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/reportservices"}>
              <IoReaderOutline /> Report Service
            </NavLink>
          </li>
        </ul>
        {user && user.role === "admin" && (
          <div>
            <p className="menu-label label mb-1 has-text-white">Master Data</p>
            <ul className="menu-list">
              <li>
                <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/products"}>
                  <IoPricetag /> Products
                </NavLink>
              </li>
              <li>
                <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/categories"}>
                  <IoBookmark /> Category
                </NavLink>
              </li>
            </ul>
            <ul className="menu-list">
              <li>
                <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/clients"}>
                  <IoPeopleCircleOutline /> Customers
                </NavLink>
              </li>
            </ul>
            <ul className="menu-list">
              <li>
                <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/users"}>
                  <IoPerson /> Users
                </NavLink>
              </li>
            </ul>

            <p className="menu-label label mb-1 has-text-white">Settings</p>
            <ul className="menu-list">
              <li>
                <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/ads"}>
                  <IoTvOutline /> Advertisement
                </NavLink>
              </li>
              <li>
                <NavLink className="pt-1 pb-1 is-size-6 has-text-white has-text-link-light" to={"/companies"}>
                  <IoBriefcaseOutline /> Company
                </NavLink>
              </li>
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

export default Sidebar;
